import React from "react";

const Create = () => {
  return <div>Create account</div>;
};

export default Create;
